<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col cols="3" class="search-col">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Поиск"
              single-line
              otlined
              hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="9" class="text-right" >
        <v-btn @click="$router.push({ name: 'street-create' })">Создать улицу</v-btn>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет улиц"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="streets"
              v-model="selected"
              :server-items-length="total"
              :items-per-page="15"
              :options.sync="options"
              :fixed-header="true"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              height="60vh"
              :footer-props="footerProps"
              :loading="loading"
              loading-text="Загрузка улиц... Подождите пожалуйста"
      >
        <template v-slot:header.area.name>
          Район<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.area.value.length > 0}"
                 @click.stop.prevent="filters.area.modal = !filters.area.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'street-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <v-dialog
              v-model="submitDialog"
              max-width="444"
      >
        <v-card>
          <v-card-title >
            Подтвердить действие
          </v-card-title>

          <v-card-actions>


            <v-btn
                    v-if="submitItem == null"
                    @click="submitDelete(submitItem); submitDialog = false">
              Да
            </v-btn>
            <v-btn
                    v-else
                    @click="submitDelete(submitItem); submitDialog = false">
              Да
            </v-btn>
            <v-btn
                    outlined
                    @click="submitDialog = false"
            >
              Нет
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--</v-card>-->
    </v-col>


    <v-dialog
        v-model="filters.area.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title >
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
              :items="areas"
              :item-text="area => area.name"
              :item-value="area => area.id"
              v-model="filters.area.tempValue"
              label="Район"
              :clearable="true"
              outlined
              multiple
              :hide-details="true"
          >
            <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="font-weight-bold">
                    Выбрано: {{ filters.area.tempValue.length }}
                  </span>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAreaFilter" >Выбрать</v-btn>

          <v-btn
              outlined
              @click="filters.area.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import StreetService from '../../../api/StreetService'
    import AreaService from "@/api/AreaService";

    export default {
        name: 'ProductIndex',
        components: {},
        data: () => ({
          filters: {
            area: {
              value: [],
              tempValue: [],
              modal: false,
            },
          },

          areas: [],
            loading: true,
            total: 0,
            selected: [],
            streets: [],
            submitDialog: false,
            submitItem: null,
            search: '',
            options: {},
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [15, 30]
            },
            headers: [
                {
                    text: 'Улица',
                    value: 'name'
                },
                {
                    text: 'Район',
                    value: 'area.name',
                    sortable: false,
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
          AreaService.list().then(response => {
            this.areas = response.data
          })
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
          search() {
            clearTimeout(this.timerId)
            this.timerId = setTimeout(() => {
              this.getDataFromApi()
            }, 700)
          }
        },
        methods: {
          submitDelete(item = null){
            if(item){
              this.removeStreet(item)
            } else {
              //this.massDelete()
            }
          },
          setAreaFilter() {
            this.filters.area.value = this.filters.area.tempValue
            this.filters.area.modal = false;
            this.overlay = false;
            this.getDataFromApi();
          },
            removeStreet(item){
              StreetService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            createStreet(){
                this.loadingModal = true;
                StreetService.create(this.street).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            updateStreet(){
                this.loadingModal = true;
                StreetService.update(this.street).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                let params = {
                  search: this.search,
                  page: this.options.page,
                  perPage: this.options.itemsPerPage,
                  sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
                  sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
                }

                if (this.filters.area.value) {
                  params.area_id = this.filters.area.value;
                }

                StreetService.list(params)
                    .then(response => {
                        this.streets = response.data.data
                        this.total = response.data.total
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
